export const ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN as string;